export const MAX_RECIPE_QUANTITY = 99999999.9999;
export const MAX_RECIPE_COMPONENTS_PER_TYPE = 200;

const DECIMAL_PATTERN = /^\d+(?:[.,]\d{1,4})?$/;

export function normalizeRecipeQuantityInput(value) {
  return String(value ?? "").replace(/\./g, ",");
}

export function formatRecipeQuantityInput(value) {
  const normalized = normalizeRecipeQuantityInput(value).trim();
  if (!normalized) return "";
  if (!/^\d+(?:,\d+)?$/.test(normalized)) return normalized;

  const [integerPart, decimalPart = ""] = normalized.split(",");
  const significantDecimals = decimalPart.replace(/0+$/, "");
  return significantDecimals
    ? `${integerPart},${significantDecimals}`
    : integerPart;
}

export function parseRecipeQuantity(value) {
  const normalized = String(value ?? "").trim().replace(",", ".");
  if (!DECIMAL_PATTERN.test(normalized)) return null;

  const quantity = Number(normalized);
  if (
    !Number.isFinite(quantity) ||
    quantity < 0.0001 ||
    quantity > MAX_RECIPE_QUANTITY
  ) {
    return null;
  }

  return quantity;
}

export function isRichTextEmpty(value) {
  return !String(value ?? "")
    .replace(/&(?:amp;)?nbsp;|\u00a0/gi, " ")
    .replace(/<br\s*\/?>/gi, "")
    .replace(/<[^>]*>/g, "")
    .trim();
}

export function componentKey(component) {
  return `${component.kind}:${component.id}`;
}

export function buildRecipePayload({
  name,
  sector,
  isActive = true,
  versionIsActive = true,
  portionQuantity,
  notes,
  components,
}) {
  const toLine = (component, idKey) => ({
    [idKey]: component.id,
    quantity: parseRecipeQuantity(component.quantity),
    notes: String(component.notes ?? "").trim() || null,
  });

  return {
    name: String(name ?? "").trim(),
    sector,
    isActive,
    version: {
      portionQuantity: parseRecipeQuantity(portionQuantity),
      notes: isRichTextEmpty(notes) ? null : String(notes).trim(),
      isActive: versionIsActive,
      ingredients: components
        .filter((component) => component.kind === "ingredient")
        .map((component) => toLine(component, "ingredientId")),
      preparedProducts: components
        .filter((component) => component.kind === "preparedProduct")
        .map((component) => toLine(component, "preparedProductId")),
    },
  };
}
